import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule, MatSliderThumb } from '@angular/material/slider';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-slider',
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  imports: [
    MatSliderModule,
    MatSliderThumb,
    ReactiveFormsModule,
  ],
})
export class FormlySliderComponent extends FieldType<FieldTypeConfig> {}
